export function extractDomainFromUrl(url: string | null): { domain: string; env: string } {
  if (!url) {
    return { domain: '', env: '' };
  }
  try {
    // Handle URLs with or without protocol
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }

    const urlObj = new URL(url);
    return { domain: urlObj.hostname, env: determineDomainEnvironmentFromDomain(urlObj.hostname) };
  } catch (e) {
    // If URL parsing fails, return the original string
    // This handles cases where the input might already be just a domain
    return {
      domain: url.split('/')[0],
      env: determineDomainEnvironmentFromDomain(url.split('/')[0]),
    };
  }
}

export function saveVisitedDomain({ domain, env }: { domain: string; env: string }): void {
  const visitedDomains = getVisitedDomains();
  // check if there is staging.dood or preprod.dood in the domain.dood to detect the domain
  // replace or add domain
  const domainIndex = visitedDomains.findIndex(domainWithEnv => domainWithEnv.domain === domain);
  if (domainIndex !== -1) {
    visitedDomains[domainIndex].env = env;
  } else {
    visitedDomains.push({ domain, env });
  }
  localStorage.setItem('visited_domain', JSON.stringify(visitedDomains));
}

export function checkEnvValidityOrReload({
  envGuessedFromDomain,
  envFromParams,
  envFromLocalStorage,
  envGuessedFromLocalDomain,
}: {
  domain: string;
  envGuessedFromDomain: string | null;
  envFromParams: string | null;
  envFromLocalStorage: string | null;
  envGuessedFromLocalDomain: string | null;
}): void {
  if (envFromParams && envFromParams !== envFromLocalStorage) {
    localStorage.setItem('env', envFromParams);
    window.location.reload();
    return;
  }
  if (envGuessedFromDomain && envGuessedFromDomain !== envFromLocalStorage) {
    if (
      envGuessedFromDomain === 'prod' &&
      (envFromLocalStorage === 'local' || envFromLocalStorage === 'prod')
    ) {
      // prod marketplace domain can be used in local
      return;
    }
    localStorage.setItem('env', envGuessedFromDomain);
    window.location.reload();
    return;
  }
  if (!envFromLocalStorage) {
    const saveEnv = envFromParams || envGuessedFromDomain || envGuessedFromLocalDomain || 'prod';
    localStorage.setItem('env', saveEnv);
    window.location.reload();
    return;
  }
}

export function determineDomainEnvironmentFromDomain(url: string) {
  return url.includes('staging.dood')
    ? 'staging'
    : url.includes('preprod.dood')
      ? 'preprod'
      : 'prod';
}

function getVisitedDomains(): { domain: string; env: string }[] {
  const visitedDomains = localStorage.getItem('visited_domain') ?? '';
  if (!visitedDomains) {
    return [];
  }
  try {
    return JSON.parse(visitedDomains);
  } catch (e) {
    return [];
  }
}
